import { Route } from '@angular/router';
import {
  authGuard,
  AuthGuard,
  ForgotPasswordComponent,
  LoginComponent,
  nonAuthGuard,
  RegisterComponent,
} from '@angular-monorepo/auth';
import { AuthenticatedLayoutComponent, NotFoundAuthenticatedComponent } from '@angular-monorepo/ui';
import { MONITORING_ROUTES } from '@angular-monorepo/monitoring';
import { DashboardComponent } from '@angular-monorepo/dashboard';
import { HomologationComponent } from '@angular-monorepo/homologation';
import { TraceComponent } from '@angular-monorepo/traceability';
import { ConnectionsComponent } from '@angular-monorepo/connections';
import { UsersComponent } from '@angular-monorepo/users';
import { ProvidersComponent } from '@angular-monorepo/providers';

export const appRoutes: Route[] = [
  {
    // A dashboard y no a login: con sesion, nonAuthGuard manda de /login a /,
    // y si / volviera a login quedaria en bucle. Sin sesion, authGuard del
    // dashboard ya lleva a /login.
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: 'login',
    canActivate: [nonAuthGuard],
    component: LoginComponent,
  },
  {
    path: 'register',
    canActivate: [nonAuthGuard],
    component: RegisterComponent,
  },
  {
    path: 'reset-password',
    canActivate: [nonAuthGuard],
    component: ForgotPasswordComponent,
  },
  {
    path: '',
    component: AuthenticatedLayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard',
      },
      {
        path: 'dashboard',
        canActivate: [authGuard],
        component: DashboardComponent,
      },
      {
        path: 'conexiones',
        canActivate: [authGuard],
        component: ConnectionsComponent,
      },
      {
        path: 'homologaciones',
        canActivate: [authGuard],
        component: HomologationComponent,
      },
      {
        // Historial de registro (trazabilidad por identificador).
        path: 'trazabilidad',
        canActivate: [authGuard],
        component: TraceComponent,
      },
      // Monitoreo, detalle de ejecucion (workflow/:id) e historial.
      ...MONITORING_ROUTES,
      {
        path: 'usuarios',
        canActivate: [authGuard],
        component: UsersComponent,
      },
      {
        path: 'proveedores',
        canActivate: [authGuard],
        component: ProvidersComponent,
      },
      {
        path: 'not-found',
        canActivate: [authGuard],
        component: NotFoundAuthenticatedComponent,
      },
      {
        path: '**',
        redirectTo: 'not-found',
      },
    ],
    canActivate: [AuthGuard],
  },
];
